<!--
  @Description 领导意见弹窗
  @Date 2021-12-26
  @Author liushuo
-->
<template>
  <div class="modal-dv">
    <vxe-modal
      v-model="isShow"
      title="领导意见"
      size="mini"
      width="40%"
      height="auto"
      @show="showWindows"
      @close="closeWindows"
    >
      <div class="edit-dv">
        <el-form
          :model="form"
          ref="FormRef"
          :validate-on-rule-change="false"
          :rules="rules"
          size="small"
        >
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="解决截止日期" prop="newDueTime">
                <el-date-picker
                  v-model="form.newDueTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行 -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="意见内容" prop="memo">
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="form.memo"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  resize="none"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="btn-dv">
        <button @click="saveOpinion">保存</button>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
export default {
  name: 'opinionEdit',
  data() {
    return {
      // 弹窗是否打开
      isShow: false,
      form: {
        iDs: [],
        newDueTime: '',
        memo: '',
      },
      rules: {},
    }
  },
  methods: {
    showWindows() {
      // this.setFormRules()
      // 赋值历史说明
      // this.setHistoryInsList()
    },
    // 监听模态框关闭
    closeWindows() {
      this.form = {
        iDs: [],
        newDueTime: '',
        memo: '',
      }
      // this.$refs['FormRef'].resetFields()
    },
    // 保存领导意见
    async saveOpinion() {
      let form = JSON.parse(JSON.stringify(this.form))
      const idList = form.iDs.map((id) => {
        return id
      })
      form = this.removeObjectNull(form)

      const { data: res } = await this.$http.post('/Common/YKCase/leader', form)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.isShow = false
      this.$message.success(res.data)

      // 重新刷新主页面（局部刷新）
      this.$parent.getListPart(idList)
      // this.$parent.getList(false, false)
    },
  },
}
</script>

<style lang="less" scoped>
@btn-dv-height: 60px;
.modal-dv {
  position: relative;
}

.edit-dv {
  width: 100%;
  height: calc(100% - @btn-dv-height);
  box-sizing: border-box;
  padding: 0 15px;
  margin: 0 auto;
}

.btn-dv {
  width: 100%;
  height: @btn-dv-height;
  .fl;

  > button {
    width: 130px;
    height: 40px;
    background-color: @primary-color;
    color: @text-color;
    outline: none;
    border: none;
    border-radius: 10px;
    transition: @normal-transition;
    font-size: 16px;
  }

  > button:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > button:active {
    opacity: 0.9;
  }
}
</style>
